import { Component, EventEmitter, Output } from '@angular/core';

@Component({
  selector: 'app-left-toggle',
  templateUrl: './left-toggle.component.html',
  styleUrls: ['./left-toggle.component.scss']
})
export class LeftToggleComponent {
  @Output() toggleSidebar = new EventEmitter<void>();

  constructor() { }



}
